import {FC, ReactNode} from 'react'
import {Link} from 'react-router-dom'
import {toAbsoluteUrl} from '../../../../_metronic/helpers'
import {AnimatedBackground} from './AnimatedBackground'

interface AuthFullScreenProps {
  children: ReactNode
}

export const AuthFullScreen: FC<AuthFullScreenProps> = ({children}) => {
  return (
    <div className='marefati-auth marefati-auth--fullscreen'>
      {/* Top header bar (Google Antigravity style): logo + Maarefati */}
      <header className='marefati-auth__header'>
        <Link to='/auth/login' className='marefati-auth__header-brand'>
          <img
            src={toAbsoluteUrl('/media/logos/maarefati-logo2.png')}
            alt='Maarefati'
            className='marefati-auth__header-logo'
          />
          <span className='marefati-auth__header-text'>MAAREFATI</span>
        </Link>
        <div className='marefati-auth__header-end' aria-hidden>
          {/* Optional: menu icon placeholder for layout balance */}
        </div>
      </header>
      <AnimatedBackground />
      <div className='marefati-auth__center'>
        <div className='marefati-auth__logo-card'>
          <img
            src={toAbsoluteUrl('/media/logos/maarefati-logo.png')}
            alt='Maarefati'
            className='marefati-auth__logo-img'
          />
          
        </div>
        <div className='marefati-auth__card-wrap'>
          {children}
        </div>
      </div>
    </div>
  )
}
